"use client";

import { useEffect } from "react";
import { wakeAzure } from "@/lib/wake-azure";

export default function WakeAzure() {
  useEffect(() => {
    wakeAzure();
  }, []);

  return null;
}
